// pages/RoleRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RoleRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const role = sessionStorage.getItem("role");

    if (!role) {
      navigate("/");
      return;
    }

    switch (role) {
      case "ADMIN":
        navigate("/dashboard");
        break;

      case "SUPERADMIN":
        navigate("/dashboard");
        break;

      case "STUDENT":
        navigate("/student");
        break;
     case "TEACHER":
        navigate("/teacher");
        break;

      default:
        navigate("/unauthorized");
    }
  }, [navigate]);

  return null;
}